<template>
  <div class="flex flex-col relative mb-10 h-screen">
    <router-link to="/teachers/carousel" class="absolute top-10 right-3 w-14 h-14 bg-white z-30
      flex items-center justify-center transform hover:scale-110 duration-300 rounded">
      <div class="w-5">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.0.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M88 48C101.3 48 112 58.75 112 72V120C112 133.3 101.3 144 88 144H40C26.75 144 16 133.3 16 120V72C16 58.75 26.75 48 40 48H88zM480 64C497.7 64 512 78.33 512 96C512 113.7 497.7 128 480 128H192C174.3 128 160 113.7 160 96C160 78.33 174.3 64 192 64H480zM480 224C497.7 224 512 238.3 512 256C512 273.7 497.7 288 480 288H192C174.3 288 160 273.7 160 256C160 238.3 174.3 224 192 224H480zM480 384C497.7 384 512 398.3 512 416C512 433.7 497.7 448 480 448H192C174.3 448 160 433.7 160 416C160 398.3 174.3 384 192 384H480zM16 232C16 218.7 26.75 208 40 208H88C101.3 208 112 218.7 112 232V280C112 293.3 101.3 304 88 304H40C26.75 304 16 293.3 16 280V232zM88 368C101.3 368 112 378.7 112 392V440C112 453.3 101.3 464 88 464H40C26.75 464 16 453.3 16 440V392C16 378.7 26.75 368 40 368H88z"/></svg>
      </div>
    </router-link>
    <div class="flex justify-center items-center w-screen flex-wrap
     bg-white z-10 md:px-10 blur h-full overflow-y-auto mt-3 mb-10 py-20">
      <teacher-card class="md:block hidden mt-10"
        v-for="teacher in filteredTeachers" :key="teacher.id"
        :teacher="teacher"
      />
      <teacher-card-mobile class="block md:hidden"
        v-for="teacher in filteredTeachers" :key="'mobile_'+teacher.id"
        :teacher="teacher"
      />
    </div>
  </div>
</template>

<script>
import TeacherCard from '@/components/teachers/TeacherCard.vue';
import { mapGetters } from 'vuex';
import { getTeachers } from '@/services/TeacherService';
import TeacherCardMobile from './TeacherCardMobile.vue';

export default {
  data() {
    return {
      teachers: [],
    };
  },

  computed: {
    ...mapGetters({
      authenticated: 'auth/authenticated',
      user: 'auth/user',
    }),

    filteredTeachers() {
      if (this.teachers.length > 0) {
        return this.teachers.filter(
          (teacher) => (!this.authenticated || teacher.user_id !== this.user.id),
        );
      }
      return true;
    },
  },

  components: {
    TeacherCard,
    TeacherCardMobile,
  },

  mounted() {
    this.loadTeachersList();
  },

  methods: {
    loadTeachersList() {
      getTeachers().then((response) => {
        this.teachers = response.data.sort(
          (teacher1, teacher2) => teacher2.stars_avg - teacher1.stars_avg,
        );
      }).catch(() => {
        this.createNotification('error', this.$t('notifications.errorReload'));
      });
    },
  },

};
</script>

<style lang="scss" scoped>
  .blur{
    background: rgb(255, 255, 255, 0.8);
    box-shadow: 0 3px 20px 0 rgba(92, 92, 92, 0.842);
    backdrop-filter: blur( 3.0px );
    -webkit-backdrop-filter: blur( 3.0px );
  }
</style>
